// src/components/GameCard.js
import React from 'react';
import { Link } from 'react-router-dom';

const GameCard = ({ game, abc, xyz }) => {
  
  const gameId = game.slug || game.id;
  const title = game.title || game.name || "Unknown Game";
  const genre = game.genre || game.category || "N/A";
  const isActive = game.isActive === 1; // 1 means active, 0 means inactive

  // prepend domain if image path doesn't already have http
  const imagePath = game.image || game.imageUrl || "";
  const image = imagePath.startsWith("http")
    ? imagePath
    : `https://api.gamegems.co${imagePath}`;

  if (!isActive) {
    return (
      <div className="block bg-gray-900/80 rounded-xl shadow p-2 relative">
        <div className="relative aspect-square">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover rounded-lg opacity-30"
          />
          <div className="absolute inset-0 flex items-center justify-center px-2">
            <span className="bg-gradient-to-r from-purple-600 to-blue-500 text-white text-[10px] sm:text-xs font-bold uppercase tracking-wider px-2 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-lg text-center">
              Coming Soon
            </span>
          </div>
        </div>
        <h3 className="text-xs sm:text-sm text-white/70 font-bold mt-2 truncate">{title}</h3>
        <p className="text-xs text-gray-500 truncate">{genre}</p>
      </div>
    );
  }

  return (
    <Link
      key={game.id}
      state={{ game, abc, xyz }}
      to={`/game-plan/${gameId}?abc=${abc}&xyz=${xyz}`}
      className="block bg-gray-900 rounded-xl shadow p-2 hover:shadow-lg transition"
    >
      <div className="aspect-square">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover rounded"
        />
      </div>
      <h3 className="text-xs sm:text-sm text-white font-bold mt-2 truncate">{title}</h3>
      <p className="text-xs sm:text-sm text-gray-400 truncate">{genre}</p>
    </Link>
  );
};

export default GameCard;
